import styled from "styled-components";

export const ErrorBannerContainer = styled.div`
  margin: 16px;
`;
